<template>
  <input
    type="checkbox"
    :checked="modelValue"
    @change="$emit('update:modelValue', $event.target.checked)"
    class="appearance-none h-6 min-w-6 !w-6 border border-gray-400 rounded-sm checked:bg-[#E8535D] checked:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-300 transition-colors"
  />
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  }
};
</script>